import { Option } from '@code/innovance-react-ui-kit';
import { useEffect, useState } from 'react';

import { Parameter } from 'src/front/api/apiInstance';
import { ReferenceDataType } from 'src/front/api/generated';

const usePRM = (referenceDataType: ReferenceDataType): Option[] => {
  const [parameters, setParamaters] = useState<Option[]>([]);

  useEffect(() => {
    (async () => {
      const { data } = await Parameter.getReferenceData({ referenceDataType });

      setParamaters(
        data.parameterDataList?.map((parameter) => ({
          value: parameter.code,
          label: parameter.value,
        })) || []
      );
    })();
  }, [referenceDataType]);

  return parameters;
};

export const useConditionalPRM = (
  referenceDataType: ReferenceDataType,
  additionalCode?: string
): Option[] => {
  const [parameters, setParamaters] = useState<Option[]>([]);

  useEffect(() => {
    if (additionalCode) {
      (async () => {
        const { data } = await Parameter.getReferenceData({ referenceDataType, additionalCode });

        setParamaters(
          data.parameterDataList?.map((parameter) => ({
            value: parameter.code,
            label: parameter.value,
          })) || []
        );
      })();
    }
  }, [additionalCode, referenceDataType]);

  return parameters;
};

export default usePRM;
